<template>
  <div class="recorder">
    <div class="session">
      <TimeCode v-if="timer" />
      <a v-if="download" class="button saveButton" :href="download" :download="`${fileName}.webm`">
        <i class="material-icons">save</i>
        <span class="text">save</span>
      </a>
      <button v-else-if="timer" class="button recordButton" @click="timer = false">
        <span class="tooltip">Stop Timer</span>
        <i class="material-icons">stop</i>
      </button>
      <button v-else class="button recordButton" @click="timer = true">
        <span class="tooltip">Begin Timer</span>
        <i class="material-icons">fiber_manual_record</i>
      </button>
      <input class="sessionName" type="text" v-if="false" v-model="name" placeholder="session_name" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TimeCode from '@/components/TimeCode'

export default {
  data: () => ({
    rec: null,
    stream: null,
    blobs: [],
    download: null,
    name: '',
    timer: false
  }),
  components: {
    TimeCode
  },
  computed: {
    fileName() {
      return this.name.replace(/[^a-z0-9]/gi, '_')
    },
    ...mapState([
      'locked'
    ])
  },
  methods: {
    stop() {
      this.rec.stop()
    },
    async capture() {
      const track = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: {
          autoGainControl: false,
          echoCancellation: false,
          googAutoGainControl: false,
          noiseSuppression: false
        }
      })
      this.stream = new MediaStream(track)
      const rec = new MediaRecorder(this.stream, {mimeType: 'video/webm; codecs=vp8'})
      rec.ondataavailable = this.dataAvailable
      rec.onstop = this.onStop
      this.rec = rec
      this.rec.start()
      this.setLocked(true)
    },
    dataAvailable(e) {
      this.blobs.push(e.data)
    },
    async onStop() {
      this.saveSession()
      this.stream.getTracks()
        .forEach(track => track.stop())
    },
    saveSession() {
      this.setLocked(false)
      const blob = new Blob(this.blobs, {type: 'video/webm'})
      this.download = window.URL.createObjectURL(blob)
    },
    ...mapMutations([
      'setLocked'
    ])
  },
}
</script>

<style lang="stylus" scoped>
</style>